// extracted by mini-css-extract-plugin
export var spanWrapper = "tooltip-module--spanWrapper--yj21E";
export var tooltip = "tooltip-module--tooltip--TkbDP";